import { render, staticRenderFns } from "./Contracts.vue?vue&type=template&id=654c63de&scoped=true&"
import script from "./Contracts.vue?vue&type=script&lang=js&"
export * from "./Contracts.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/all-admin.css?vue&type=style&index=0&id=654c63de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654c63de",
  null
  
)

export default component.exports